const EnvironmentThemeProvider = require('@codex/themes').EnvironmentThemeProvider;
const React = require('react');
const ReactDOM = require('react-dom');
const Icon = require('@codex/icons').Icon;

const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(customParseFormat);

const Helpers = require('./mcd-postcode-check-helpers');
const uiLocale = require('./utils/UILocale');

const Analytics = require('./analytics');
const Product = require('./product');

const collectInStore = require('./collect-in-store');

const LocationService = require('./locationservice');
const LocationStatus = require('./locationstatus');
const ProductAvailability = require('./productavailability');

let wrapper = null;
let currentLocation = null;

function initElementWrappers(channelsPanel) {

  const locationSearchWrapper = channelsPanel.find('.check-delivery-options');
  const mcdPanels = channelsPanel.next('.mcd-tabs');

  const deliveryButton = mcdPanels.find('.mcd-delivery-button');
  const collectionButton = mcdPanels.find('.mcd-stores-button');

  const chevronOfDeliveryButton = deliveryButton.find('.right-button');
  const chevronOfCollectionButton = collectionButton.find('.right-button');

  const channels = channelsPanel.find('.prd-channels');
  const feedbacks = mcdPanels.find('.mcd-feedback');

  const deliverySlotsEl = mcdPanels.find('.delivery-slot-picker');
  const infoBox = mcdPanels.find('.hd-postcode-info');
  const postcodeNewSelection = infoBox.find('#pc-for-new-selection');
  const postcodeItemsInBasket = infoBox.find('#pc-for-items-in-basket');

  const form = channelsPanel.find('form.postcode-checker');
  const loader = form.find('.mcd-loader').hide();
  const techError = form.prevAll('.error-feedback');
  const help = form.find('.help');

  const safetyStepEl = mcdPanels.find('.delivery-safety-step');
  const showDeliveryBtn = safetyStepEl.find('.bt');
  const freeDeliveryAddToBasketButtonPanel = mcdPanels.find('.sb-free-delivery-button');
  const checkCollectInsteadSafetyStep = safetyStepEl.find('.pt10');
  const checkCollectInstead = mcdPanels.find('.check-collect-instead');
  const checkDeliveryInstead = mcdPanels.find('.check-delivery-instead');
  const deliverySlotsOffMsg = mcdPanels.find('.delivery-slots-disabled');
  const deliveryLoader = mcdPanels.find('.delivery-slots-loader');
  const tradeplaceUndeliverableElt = feedbacks.find('.mcd-tradeplace-undeliverable');
  const collectStoreAltElt = mcdPanels.find('.mcd-reserve-store-alt');

  const stickyFooter = $('#product-actions-toggle');
  const countdownPlaceholder = mcdPanels.find('.countdown-placeholder-mcd');

  renderChevronButton(chevronOfDeliveryButton, 90);
  renderChevronButton(chevronOfCollectionButton, 90);

  mcdPanels.find('.change-location a, .stock-availability a').on('click', (event) => {
    LocationService.clearLocation(true);
    event.stopPropagation();
    event.preventDefault();
  });

  deliveryButton.click((e) => {
    if (!deliveryButton.hasClass('disabled')) {
      if (deliveryButton.hasClass('opened')) {
        closeDeliveriesInfo();
      } else {
        openDeliveriesInfo();
        if (!collectionButton.hasClass('disabled')) {
          closeStoresInfo();
        }

      }
    }
  });

  collectionButton.click((e) => {
    if (!collectionButton.hasClass('disabled')) {
      if (collectionButton.hasClass('opened')) {
        closeStoresInfo();
      } else {
        openStoresInfo();
        if (!deliveryButton.hasClass('disabled')) {
          closeDeliveriesInfo();
        }
      }
    }
  });

  collectionButton.on('click', () => {
    Analytics.track('collectInStoreDisplayed');
  });

  checkCollectInstead.find('a').click((e) => {
    e.preventDefault();
    openStoresInfo();
    closeDeliveriesInfo();
    scrollToTopOfMCD($(e.target));
  });

  checkDeliveryInstead.find('a').click((e) => {
    e.preventDefault();
    openDeliveriesInfo();
    closeStoresInfo();
    scrollToTopOfMCD($(e.target));
  });

  function openDeliveriesInfo() {
    deliveryButton.addClass('opened').removeClass('closed disabled');
    renderChevronButton(chevronOfDeliveryButton, 270);
  }
  function closeDeliveriesInfo() {
    deliveryButton.addClass('closed').removeClass('opened disabled');
    renderChevronButton(chevronOfDeliveryButton, 90);
  }

  function disableDeliveriesInfo() {
    deliveryButton.find('.button-header-text')
      .text(uiLocale.getString('component.mcd.touch.delivery.unavailable'));
    deliveryButton.addClass('disabled').removeClass('opened closed');
  }
  function openStoresInfo() {
    collectionButton.addClass('opened').removeClass('closed disabled');
    renderChevronButton(chevronOfCollectionButton, 270);
    scrollToChannelsButtons();
  }
  function closeStoresInfo() {
    collectionButton.addClass('closed').removeClass('opened disabled');
    renderChevronButton(chevronOfCollectionButton, 90);
  }

  function disableStoresInfo() {
    collectionButton.find('.button-header-text')
      .text(uiLocale.getString('component.mcd.touch.collection.unavailable'));
    collectionButton.addClass('disabled').removeClass('opened closed');
  }

  function scrollToTopOfMCD(clickedLink) {
    const linkDistanceFromTop = clickedLink.closest('.tabs-content')
      .find('.stock-availability')[0].getBoundingClientRect().top;

    if (typeof window.scrollY === 'undefined' || typeof linkDistanceFromTop === 'undefined') {
      // fallback for IE 11 and old Edge browsers
      clickedLink.closest('.tabs-content')
        .find('.stock-availability')[0].scrollIntoView();
    } else {
      const scrollDistance = window.scrollY + linkDistanceFromTop;

      window.scrollTo({
        top: scrollDistance - 62, // 62 is subtracted beacuse of height of header
        behavior: 'smooth'
      });

    }
  }

  function scrollToChannelsButtons() {
    const linkDistanceFromTop =
      $('#product-actions-touch [data-component="channels-panel"]')[0].getBoundingClientRect().top;

    // this is here because of touch header height
    if (typeof window.scrollY === 'undefined' || typeof linkDistanceFromTop === 'undefined') {
      // fallback for IE 11 and old Edge browsers
      $('#product-actions-touch [data-component="channels-panel"]')[0].scrollIntoView();
    } else {
      const scrollDistance = window.scrollY + linkDistanceFromTop;

      window.scrollTo({
        top: scrollDistance - 62, // 62 is subtracted beacuse of height of header
        behavior: 'smooth'
      });
    }
  }

  /** @param {Promise} cancellable
      @returns {Promise} */
  function beginAvailabilityRequest(cancellable) {
    if ($('.error-placeholder').css('display') === 'block') {
      return;
    }
    techError.add(help).hide();
    stickyFooter.hide();

    const request = new Promise(((resolve, reject) => {
      const productDelivery = document.querySelector('.check-delivery-options');
      const product = new Product(productDelivery.getAttribute('data-productid'));
      product.getAvailability(currentLocation, resolve, reject);
    }));

    return Promise.race([request, cancellable]).then( // eslint-disable-line consistent-return
      (result) => { // eslint-disable-line consistent-return
        if (result instanceof ProductAvailability) {
          // Resolved by ProductAvailability
          onAvailabilitySuccess(result);
          // dispatching of the data-layer redux action
          if (window.appState) {
            window.appState.dispatch({
              type: 'EVENTS_STOCK_AVAILABILITY',
              payload: {
                products: [{
                  productID: window.digitalData.product[0].productID,
                  productSKU: window.digitalData.product[0].productSKU,
                  productName: window.digitalData.product[0].productName,
                  availabilityStatus: `${result.getDeliveryState()}|${result.getCollectionState()}`
                }]
              }
            });
          }
        } else {
          // Resolved by Cancellable - probably a timeout
          return Promise.reject(new LocationStatus(LocationService.LocationState.TIMEOUT,
            'Timeout during gathering location'));
        }
      },
      (reason) => {
        let errorMessage = reason;
        // Rejected by API call
        if (!(typeof reason === 'string')) {
          errorMessage =
            window.App.locale.getFormattedString('component.locationsearch.locationerror',
              {
                location: LocationService.getLocation().location ||
                  LocationService.getLocation()
              });
        }
        return Promise.reject(
          new LocationStatus(LocationService.LocationState.ERROR, errorMessage)
        );
      }
    ).catch((reason) => {
      // report runtime errors thrown in availability-related code inside the promise
      console.error(reason);
    });

  }

  function resetAvailability() {
    deliveryButton.removeClass('opened disabled').addClass('closed');
    collectionButton.removeClass('opened disabled').addClass('closed');

    deliveryButton.add(collectionButton).find('.second-line-info, .third-line-info').text('');

    mcdPanels.add(help)
      .add(safetyStepEl)
      .add(tradeplaceUndeliverableElt)
      .add(collectStoreAltElt)
      .add(deliverySlotsEl)
      .add(infoBox)
      .add(deliverySlotsOffMsg)
      .hide();
    locationSearchWrapper.add(channelsPanel)
      .add(freeDeliveryAddToBasketButtonPanel)
      .add(checkCollectInstead)
      .show();
    // postcodeInputElt.focus();
    showDeliveryBtn.unbind('click');
    locationSearchWrapper.removeClass('postcode-error-state');
    countdownPlaceholder.show();
  }

  function updateStockAvailabilityLinkLabel(productAvailability) {
    mcdPanels.find('.stock-availability a').text(
      productAvailability.getLocation().location ||
      productAvailability.getLocation()
    );
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateLocationFeedback(productAvailability) {

    let tabType;
    let tabLabel;
    let tabState;

    loader.add(locationSearchWrapper).add(channelsPanel).hide(); // hide spinner
    channelsPanel.show(); // show add to basket button and download button (whole channels box)

    feedbacks.each(function callback() {
      const feedback = $(this);

      if (feedback.parents('.touch-tab').hasClass('mcd-touch-tab1')) {
        tabType = 'tab1';
        tabLabel = productAvailability.getDeliveryLabel();
        tabState = productAvailability.getDeliveryState();
      } else {
        tabType = 'tab2';
        tabLabel = productAvailability.getCollectionLabel();
        tabState = productAvailability.getCollectionState();
      }

      // When no availability of both Home Delivery and
      // Collect at Store for postcode, hide tabs and display proper message
      if (productAvailability.isUndeliverablePostcode() &&
        productAvailability.isUnCollectablePostcode()) {
        closeDeliveriesInfo();
        closeStoresInfo();

        disableDeliveriesInfo();
        disableStoresInfo();

      } else {
        Helpers.updateFeedback(feedback, tabType, currentLocation.location, tabLabel,
          productAvailability.getAvailabilityInfo(), tabState);

        openDeliveriesInfo();
        closeStoresInfo();
        freeDeliveryAddToBasketButtonPanel.hide();
        countdownPlaceholder.hide();
      }
    });

    // display tabs always (even for tradeplace)
    mcdPanels.show();
  }

  // add info to buttons
  function updateLabelsInButtons(productAvailability) {

    // setting labels for delivery button
    if (productAvailability.hasDeliverySlots()) {
      // setting header label
      deliveryButton.find('.button-header-text').text(
        `${uiLocale.getString('component.mcd.touch.home.delivery.from')} ` +
        `${productAvailability.getPriceStringOfCheapestSlot()}`
      );

      // setting label for second-line info
      if (productAvailability.isNextDayDeliveryAvailable()) {
        deliveryButton.find('.second-line-info').text(
          uiLocale.getString('component.mcd.touch.nextday.delivery.available')
        );

      } else {
        // earliest delivery in second line info
        // TODO: add text to translations
        const earliestDate = productAvailability.getEarliestDeliveryDateString();
        deliveryButton.find('.second-line-info')
          .text(`Earliest delivery date is on ${earliestDate}`);
      }

      // setting label for third line info
      if (freeDeliveryAddToBasketButtonPanel.length === 1) {
        // Add free delivery message for small box
        deliveryButton.find('.third-line-info').text(
          freeDeliveryAddToBasketButtonPanel.find('.free-delivery-date.free-delivery')
            .text().replace('Free', 'FREE').replace('delivery', 'Delivery')
        );
      } else {
        const soonestFreeDeliveryDate =
          productAvailability.getFreeDeliverySoonestDateFromDeliverySlots();
        if (soonestFreeDeliveryDate) {
          // Add free delivery message for other product types
          const parsedDate = dayjs(new Date(soonestFreeDeliveryDate));

          deliveryButton.find('.third-line-info').text(
            window.App.locale.getFormattedString(
              'component.deliveryslotpicker.free.label',
              { date: parsedDate.format('Do MMM') }
            ).replace('Free', 'FREE').replace('delivery', 'Delivery')
          );

        } else {
          // no label
          deliveryButton.find('.third-line-info').text('');
        }
      }
    } else if (productAvailability.isDeliverable()) {
      // product is deliverable for this postcode but has no slots on product page to show
      deliveryButton.find('.button-header-text').text('Home delivery available');
      deliveryButton.find('.third-line-info, .second-line-info').text('');
    }

    // setting labels for collection button
    if (productAvailability.isCollectable()) {
      // setting header label
      collectionButton.find('.button-header-text').text(
        uiLocale.getString('component.mcd.touch.collect.for.free')
      );

      // setting second line label
      const storeWithStock = productAvailability.getAvailableStores()[0].isOutOfStock() ? 1 : 0;
      collectionButton.find('.second-line-info').text(
        `Available ${productAvailability.getAvailableStores()[storeWithStock].getStoreDistance()}`
      );
    } else {
      // no label for second line
      collectionButton.find('.third-line-info').text('');
    }

  }

  /**
   * handles result for tradeplace
   * @param productAvailability
   */
  function updateTradeplaceProduct(productAvailability) {
    openDeliveriesInfo();
    closeStoresInfo();

    disableStoresInfo();

    checkCollectInstead.hide();
    if (!productAvailability.isDeliverable() && productAvailability.getProductSegment()) {
      Helpers.setUndeliverableLinks(
        tradeplaceUndeliverableElt, productAvailability.getProductSegment()
      );
    }
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateUndeliverableProduct(productAvailability) {
    if (productAvailability.isUnDeliverable()) {

      openStoresInfo();
      closeDeliveriesInfo();

      disableDeliveriesInfo();

      checkDeliveryInstead.hide();
    } else if (productAvailability.isUndeliverablePostcode()) {
      openDeliveriesInfo();
      closeStoresInfo();
      deliveryLoader.hide();

      deliveryButton.find('.button-header-text')
        .text(productAvailability.getDeliveryLabel());
      if (productAvailability.isCollectable()) {
        checkCollectInstead.hide();
        collectStoreAltElt.show();
        updateStockAvailabilityLinkLabel(productAvailability);
        updateLocationFeedback(productAvailability);
        updateLabelsInButtons(productAvailability);
      } else if (productAvailability.isUnCollectablePostcode()) {
        checkCollectInstead.hide();
      }
      freeDeliveryAddToBasketButtonPanel.hide();
    }
  }

  /** @param {ProductAvailability} productAvailability */
  /** @param {array<Object>} deliverySlots */
  /** @returns {void} */
  function updateProductDelivery(productAvailability, deliverySlots) {
    if (productAvailability.hasDeliverySlots()) {
      Helpers.updateProductDeliveriesSlot(
        productAvailability, deliverySlots,
        deliveryLoader, countdownPlaceholder, checkCollectInstead, postcodeNewSelection,
        postcodeItemsInBasket, infoBox, deliverySlotsEl, freeDeliveryAddToBasketButtonPanel
      );
    } else if (productAvailability.isUndeliverablePostcode()) {
      // This handles the special case when safety step is active and
      // in second call it becomes undeliverable to poscode for any reason
      updateStockAvailabilityLinkLabel(productAvailability);
      updateLocationFeedback(productAvailability);
      updateUndeliverableProduct(productAvailability);
      updateLabelsInButtons(productAvailability);
      countdownPlaceholder.hide();
    } else {
      openStoresInfo();
      closeDeliveriesInfo();

      disableDeliveriesInfo();
      checkDeliveryInstead.hide();
    }
  }

  /** @param {string} message */
  /** @returns {void} */
  function onDeliveryError(message) {
    deliverySlotsEl.show();
    deliveryLoader.hide();
    Helpers.showMainError(
      channelsPanel, locationSearchWrapper, channels, techError, help, mcdPanels, loader
    );
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function offerProductDeliveryOptions(productAvailability) {

    // TODO: check what is tabs and consider remove it
    openDeliveriesInfo();
    Helpers.offerProductDeliveryOptions(
      safetyStepEl, checkCollectInstead, countdownPlaceholder, showDeliveryBtn, deliverySlotsEl,
      freeDeliveryAddToBasketButtonPanel, deliveryLoader, productAvailability,
      updateProductDelivery, onDeliveryError
    );
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateCollectInStore(productAvailability) {
    checkDeliveryInstead.hide();
    collectInStore.clearStoresList();
    if (productAvailability.isCollectable()) {
      collectInStore.initialise(
        productAvailability.getAvailableStores(),
        productAvailability.isPayAndCollectFromStoreStockEnabled()
      );
      if (productAvailability.isUnDeliverable()) {
        checkDeliveryInstead.hide();
      }
    } else if (productAvailability.isUncollectable()) {
      disableStoresInfo();

      checkCollectInstead.hide();
      checkCollectInsteadSafetyStep.hide();
    } else if (productAvailability.isUncollectableOutOfStock() &&
      !productAvailability.isUnDeliverable()) {
      collectionButton.find('.button-header-text').text(
        `${productAvailability.getCollectionLabel()} ${currentLocation.location}`
      );

      checkDeliveryInstead.show();
    } else if (productAvailability.isDeliverable()) {
      checkDeliveryInstead.show();
    } else if (productAvailability.isUnCollectablePostcode()) {
      deliveryButton.find('.button-header-text').text(
        `${productAvailability.getDeliveryLabel()} ${currentLocation.location}`
      );
    } else {
      checkCollectInstead.hide();
      collectionButton.find('.button-header-text').text(
        `${productAvailability.getCollectionLabel()} ${currentLocation.location}`
      );
    }
  }

  /**
   * handles the productAvailability result from the api and updates the UI
   * @param productAvailability
   * todo high cyclomatic complexity here
   */
  function onAvailabilitySuccess(productAvailability) {
    Helpers.trackAvailabilityAnalytics(productAvailability);

    scrollToChannelsButtons();

    updateStockAvailabilityLinkLabel(productAvailability);
    updateLocationFeedback(productAvailability);
    updateLabelsInButtons(productAvailability);

    if (productAvailability.isTradeplaceProduct()) {
      updateTradeplaceProduct(productAvailability);
    } else if (productAvailability.isDeliverable() === false) {
      updateUndeliverableProduct(productAvailability);
    } else if (productAvailability.hasDeliverySlots()) {
      productAvailability.getProductDelivery(updateProductDelivery, onDeliveryError);
    } else if (productAvailability.isDeliveryStepEnabled()) {
      offerProductDeliveryOptions(productAvailability);
    } else if (!productAvailability.hasDeliverySlots() &&
      productAvailability.getProductType() === 'SMALLBOX') {
      freeDeliveryAddToBasketButtonPanel.show();
    }
    updateCollectInStore(productAvailability);

    if (!productAvailability.hasDeliverySlots() &&
      !productAvailability.isTradeplaceProduct()) {
      deliverySlotsOffMsg.css('display', 'block');
    }

    if (productAvailability.getDeliveryState() === 'UNDELIVERABLE_OUT_OF_STOCK') {
      const deliveriesContent = mcdPanels.find('.mcd-touch-tab1');

      Helpers.createUdeliverableOutOfStockContent(
        countdownPlaceholder, deliveriesContent, productAvailability
      );
    }

    if (productAvailability.isUndeliverablePostcode()) {
      countdownPlaceholder.hide();
    } else if (productAvailability.isDeliveryStepEnabled()) {
      countdownPlaceholder.hide();
    }

    // both dropdowns should be closed by default (don't remove disabled)
    deliveryButton.addClass('closed').removeClass('opened');
    renderChevronButton(chevronOfDeliveryButton, 90);
    collectionButton.addClass('closed').removeClass('opened');
    renderChevronButton(chevronOfCollectionButton, 90);
  }

  function renderChevronButton(button$, rotationAngle) {
    button$.each((i, buttonEl) => {
      ReactDOM.render(
        <EnvironmentThemeProvider>
          <Icon
            icon={'ChevronRight'}
            style={{ width: '34px', height: '34px', color: '#4855a0' }}
            rotate={rotationAngle}
          />
        </EnvironmentThemeProvider>,
        buttonEl
      );
    });
  }

  return {
    beginAvailabilityRequest: beginAvailabilityRequest,
    resetAvailability: resetAvailability,
    onAvailabilitySuccess: onAvailabilitySuccess
  };

}

module.exports = {
  init: function() {
    // remove desktop mcd tabs
    $('.mcd-tabs-desktop').detach();

    const channelsPanel = $('[data-component="channels-panel"]');
    wrapper = initElementWrappers(channelsPanel);
  },

  /** @param {LocationDescriptor} location
      @param {Promise} cancellable
      @returns {Promise} */
  getProductAvailability: function(location, cancellable) {
    currentLocation = location;
    return wrapper.beginAvailabilityRequest(cancellable);
  },

  setLocationFeedback: function setLocationFeedback(productAvailability) {
    currentLocation = {
      location: productAvailability.getLocation(),
      postcode: productAvailability.getLocation()
    };
    return wrapper.onAvailabilitySuccess(productAvailability);
  },

  /** @returns {void} */
  clearProductAvailability: function() {
    wrapper.resetAvailability();
  }
};
